import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { userStore } from '../user.store';

@Injectable({
  providedIn: 'root',
})
export class NotAuthGuard {
  readonly store = inject(userStore);
  readonly router = inject(Router);

  constructor() {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.store.isAuthentified() === true || localStorage.getItem('isAuthentified') === 'true') {
      this.router.navigate(['/portail']);
      return false;
    }
    return true;
  }
}
